import { render, staticRenderFns } from "./WorkbenchMain.vue?vue&type=template&id=57f8b0e6&scoped=true&"
import script from "./WorkbenchMain.vue?vue&type=script&lang=js&"
export * from "./WorkbenchMain.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchMain.css?vue&type=style&index=0&id=57f8b0e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8b0e6",
  null
  
)

export default component.exports